// src/i18n/index.js
import { createI18n } from "vue-i18n";

const savedLocale = localStorage.getItem("quanty_lang") || "es";

const messages = {
  es: {
    pronostico: {
      discountCode: "Código de descuento",
      discountPlaceholder: "Ej: QUANTY10",
      applied: "Aplicado",
      apply: "Aplicar",
      onlyOneCode: "Solo puedes usar un código por compra",
      totalToPay: "Total a pagar",
      trialHoyPagas: "Hoy pagarás",
      trialCargo: "en {days} días se hará un cargo de",
      youSave: "AHORRAS",
      finalChargeEuro: "Cobro final en € (importe aproximado en {currency}).",
      phoneInvalid: "El teléfono indicado es erróneo",
      finalPrice: "Precio final",
      processingPayment: "Procesando pago… (puede tardar unos segundos)",
      loggedAs: "Estás conectado como:",
      yourLinkIs: "Este es tu enlace:",
      goToPanel: "Ir al panel",
      pay: "Pagar",
      phone: "Teléfono",
      password: "Clave",
      sendPassword: "Envíame la clave",
      login: "Iniciar sesión",
      namePlaceholder: "Indique su nombre",
      name: "Nombre",
      acceptData: "Acepto el tratamiento informatizado de la información…",
      register: "Registrarme",
      telegramCode: "Código enviado Telegram",
      codePlaceholder: "Indique el código",
      confirm: "Confirmar",
      directPurchaseTitle: "Compra Directa Sin Registro",
      directPurchaseSubtitle: "Realiza tu pago con Stripe",
      email: "Correo electrónico *",
      emailPlaceholder: "tu{'@'}correo.com",
      emailHelp: "Introduce un email válido, te enviaremos los detalles de tu compra a esa dirección.",
      country: "País de compra *",
      countryPlaceholder: "Selecciona tu país",
      countryHelp: "Esto nos ayuda con la facturación.",
      countryRequired: "Por favor, selecciona tu país para continuar.",
      acceptTerms: "He leído y confirmo que soy mayor de 18 años y acepto el {aviso} y la {privacidad}.",
      continuePayment: "Continuar con el pago",
      back: "⬅️ Volver",
      paymentCompleted: "🎉 ¡Pago completado!",
      forecastAvailable: "Tu pronóstico ya está disponible. Aquí tienes tu enlace:",
      linkPending: "Tu enlace de acceso está siendo generado. Si no lo recibes en unos minutos, contacta con soporte.",
      thanks: "El equipo de Quanty te agradece la confianza.",
      enjoy: "Disfruta tu contenido y… que empiece la racha ganadora.",
      expiredTitle: "Servicio expirado",
      expiredDefault: "Este servicio ha finalizado y ya no admite nuevas compras.",
      backHome: "Volver al inicio",
      reload: "Recargar",
      expiredHelp: "Si crees que es un error, prueba recargar o contacta con soporte.",
      countdownDays: "Quedan {d}d {h}h {m}m {s}s para adquirir",
      countdownHours: "Quedan {h}h {m}m {s}s para adquirir",

      couponNoAvailable: "Este producto no tiene descuentos disponibles",
      couponEnterCode: "Ingrese un código",
      couponAppliedOk: "Código aplicado correctamente",
      couponInvalid: "Código inválido",
      couponCheckError: "Error verificando el código",

      swalPhoneInvalid: "El teléfono es erróneo",
      swalNameLength: "El nombre debe tener más de 10 caracteres",
      swalAcceptConditions: "Debe aceptar las condiciones de registro",
      swalTelegramCode: "Indique el código enviado a su Telegram",
      swalGenericError: "Se ha producido un error",
      swalCodeSixDigits: "El código consta de 6 números",
      swalUserRegistered: "Hemos registrado su usuario",
      swalInvalidAccess: "Datos de acceso erróneos",
      swalNoPaymentConfirmation: "No se puede obtener la confirmación del pago.",
      swalPaymentPending: "Pago recibido, pero el servidor aún no lo confirmó. Espera unos segundos y recarga.",
      swalPasswordSent: "Hemos enviado una nueva clave a su Telegram",
      loginToPayLabel: "Iniciar sesión",
      subscriptionRequiresAccount: "Esta suscripción requiere cuenta",
      subscriptionRequiresAccountDesc: "Para comprar una suscripción debes iniciar sesión o crear una cuenta gratuita.",
      subscriptionLogin: "Iniciar sesión",
      subscriptionRegister: "Crear cuenta gratis",
      subscriptionLabel: "Suscripción",
      registroInlineTitulo: "Crear cuenta para suscribirte",
      registroInlineNombre: "Nombre",
      registroInlineEmail: "Email",
      registroInlinePais: "País",
      registroInlinePaisPlaceholder: "Selecciona tu país",
      registroInlinePassword: "Contraseña",
      registroInlinePasswordConfirm: "Confirmar contraseña",
      registroInlinePasswordPlaceholder: "Mínimo 8 caracteres",
      registroInlineRepeatPlaceholder: "Repite la contraseña",
      registroInlineLegal: "He leído y confirmo que soy mayor de 18 años y acepto el {aviso} y la {privacidad}.",
      registroInlineAvisoLegal: "Aviso Legal",
      registroInlinePrivacidad: "Política de Privacidad",
      registroInlineBtn: "Crear cuenta y suscribirme",
      registroInlineCargando: "Creando cuenta…",
      registroInlineYaTengo: "¿Ya tienes cuenta?",
      registroInlineIniciar: "Iniciar sesión",
      registroInlineErrorNombre: "El nombre es obligatorio.",
      registroInlineErrorEmail: "El email es obligatorio.",
      registroInlineErrorPais: "El país es obligatorio.",
      registroInlineErrorEmailTaken: "Ya existe una cuenta con ese email. Inicia sesión o usa otro.",
      registroInlineErrorPassword: "La contraseña debe tener al menos 8 caracteres.",
      registroInlineErrorMatch: "Las contraseñas no coinciden.",
      registroInlineErrorLegal: "Debes confirmar que eres mayor de 18 años y aceptar las condiciones.",
      periodDiario: "día",
      periodSemanal: "semana",
      periodQuincenal: "2 sem.",
      periodMensual: "mes",
      periodTrimestral: "3 meses",
      periodSemestral: "6 meses",
      periodAnual: "año"
    },
    paymentStripe: {
      payWithCard: "PAGAR CON TARJETA",
      cardNumber: "Nº Tarjeta",
      expiry: "Caducidad",
      securityCode: "Cód. Seguridad",
      pay: "PAGAR",
      paymentSuccess: "✅ Pago realizado con éxito",
      paymentProcessingError: "Se produjo un error procesando el pago. Inténtalo nuevamente.",
      paymentConfirmedButError: "⚠️ Tu pago fue procesado por Stripe, pero ocurrió un error al activar tu acceso. Contacta con soporte indicando tu email y el producto comprado.",
      paymentProcessing: "⏳ Tu pago está siendo procesado. Recibirás confirmación en breve.",
      paymentUnexpectedStatus: "Estado de pago inesperado. Contacta con soporte si no recibiste el acceso.",
      trialActivate: "ACTIVAR PERIODO DE PRUEBA",
      trialStart: "EMPEZAR PRUEBA GRATIS",
      trialSuccess: "✅ ¡Periodo de prueba activado! Ya tienes acceso.",
      trialDaysSingular: "día gratis",
      trialDaysPlural: "días gratis",
      trialNoChrge: "Solo verificamos tu tarjeta, no se realiza ningún cobro ahora",
      trialNote: "Podrás cancelar en cualquier momento antes del fin del periodo gratuito.",
      trialInfoSub: "El primer cobro se realiza al finalizar el periodo de prueba"
    },
    countries: {
      ES: "España",
      FR: "Francia",
      PT: "Portugal",
      DE: "Alemania",
      IT: "Italia",
      NL: "Países Bajos",
      BE: "Bélgica",
      IE: "Irlanda",
      GB: "Reino Unido",
      CH: "Suiza",
      AT: "Austria",
      SE: "Suecia",
      NO: "Noruega",
      DK: "Dinamarca",
      FI: "Finlandia",
      PL: "Polonia",
      MX: "México",
      AR: "Argentina",
      CL: "Chile",
      CO: "Colombia",
      PE: "Perú",
      EC: "Ecuador",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivia",
      VE: "Venezuela",
      BR: "Brasil",
      US: "Estados Unidos",
      CA: "Canadá",
      SV: "El Salvador",
      GT: "Guatemala",
      HN: "Honduras",
      NI: "Nicaragua",
      CR: "Costa Rica",
      PA: "Panamá",
      DO: "Rep. Dominicana",
      CU: "Cuba",
      PR: "Puerto Rico",
      AU: "Australia"
    },
    panelCliente: {
      inicio: "Inicio",
      titulo: "Panel Cliente",
      subtitulo: "Consulta tus servicios, compras y accesos vinculados a tu cuenta.",
      cliente: "Cliente",
      miCuenta: "-- Mi cuenta --",
      cargandoClientes: "Cargando clientes...",
      actualizar: "Actualizar",
      errorCargar: "No se pudo cargar el panel del cliente",
      resumenTitulo: "Resumen",
      clienteLabel: "Cliente:",
      serviciosComprados: "Servicios comprados",
      serviciosActivos: "Servicios activos",
      canalesUnidos: "Canales unidos",
      devoluciones: "Devoluciones",
      ultimaCompra: "Última compra",
      sinDatos: "Todavía no hay compras ni accesos vinculados a esta cuenta. Cuando el flujo de clientes quede conectado, aquí aparecerá toda la información.",
      datosCuentaTitulo: "Datos de la cuenta",
      datosCuentaSubtitulo: "Información básica del cliente",
      nombre: "Nombre",
      usuario: "Usuario",
      email: "Email",
      telegram: "Telegram",
      noVinculado: "No vinculado",
      emailVerificado: "Email verificado",
      si: "Sí",
      no: "No",
      alta: "Alta",
      suscrTitulo: "Mis suscripciones",
      suscrVacio: "No hay suscripciones activas en este momento.",
      producto: "Producto",
      canal: "Canal",
      estado: "Estado",
      proximoCobro: "Próximo cobro",
      desde: "Desde",
      accion: "Acción",
      ultimoDiaFree: "Último día free",
      diasFree: "{n} días free",
      cancelando: "Cancelando...",
      cancelar: "Cancelar",
      estadoActiva: "Activa",
      estadoGracia: "Gracia",
      estadoCancelada: "Cancelada",
      estadoVencida: "Vencida",
      confirmarCancelTitulo: "¿Cancelar suscripción?",
      confirmarCancelMsg: '¿Seguro que quieres cancelar "{nombre}"? Perderás el acceso al canal al finalizar el periodo actual.',
      siCancelar: "Sí, cancelar",
      canceladaOk: "Suscripción cancelada correctamente.",
      canceladaErr: "No se pudo cancelar la suscripción.",
      historialTitulo: "Historial de pedidos",
      historialVacio: "Todavía no hay pedidos registrados en esta cuenta.",
      referencia: "Referencia",
      fecha: "Fecha",
      devolucion: "Devolución",
      devolucionSolicitada: "Solicitada / procesada",
      serviciosActivosTitulo: "Servicios activos",
      serviciosActivosVacio: "Todavía no hay servicios activos vinculados a esta cuenta.",
      tipster: "Tipster",
      fechaCompra: "Fecha compra",
      acceso: "Acceso",
      sinEnlace: "Este servicio no tiene enlace de unión disponible.",
      enlaceDeUnion: "Enlace de unión",
      enlaceMsg: "Servicio: {nombre}\n\nEnlace:\n{enlace}",
      cerrar: "Cerrar",
      actividadTitulo: "Actividad en canales",
      actividadVacio: "Aún no hay actividad en canales vinculada a esta cuenta.",
      idioma: "Idioma",
      ultimaEntrada: "Última entrada",
      ultimaSalida: "Última salida",
      reingresos: "Reingresos",
      activo: "Activo",
      suscrPagInfo: "Mostrando {desde} a {hasta} de {total} suscripciones",
      historialPagInfo: "Mostrando {desde} a {hasta} de {total} pedidos",
      serviciosPagInfo: "Mostrando {desde} a {hasta} de {total} servicios",
      paginaDeTotal: "Página {page} de {total}",
    },
    perfil: {
      inicio: "Inicio",
      titulo: "Mi perfil",
      infoBasicaTitulo: "Información básica",
      nombre: "Nombre",
      email: "Email",
      actualizar: "Actualizar",
      datosTipsterTitulo: "Datos del tipster",
      contacto: "Contacto",
      telefono: "Teléfono",
      telefonoPlaceholder: "Indique teléfono",
      guardarDatos: "Guardar datos",
      cambioClaveTitulo: "Cambio de clave",
      nuevaClave: "Nueva clave",
      confirmaNuevaClave: "Confirma nueva clave",
      cambiarClave: "Cambiar clave",
      stripeTitulo: "Pasarela de pago (Stripe)",
      stripeAyudaTitulo: "¿Qué es cada clave?",
      clavePublica: "Clave pública",
      claveSecreta: "Clave secreta",
      configurada: "✓ Configurada",
      configurado: "✓ Configurado",
      generarUrl: "Generar URL personalizada",
      guardarParaUrl: "Guarda tus claves para obtener la URL única de webhook de tu cuenta.",
      copiar: "Copiar",
      copiado: "✓ Copiado",
      webhookSecret: "Webhook Secret",
      suscripciones: "Suscripciones",
      graciaPagosFallidos: "Gracia pagos fallidos",
      probarConexion: "⚡ Probar conexión",
      guardarStripe: "Guardar Stripe",
      eliminarIntegracion: "Para eliminar la integración propia, borra la clave pública y guarda con la secreta en blanco.",
      webhookGuiaTitulo: "⚡ ¿Cómo configurar el Webhook en Stripe?",
      applePayGuiaTitulo: "🍎 ¿Cómo activar Apple Pay en Stripe?",
      graciaAyudaTitulo: "¿Para qué sirve el periodo de gracia?",
      clavesCambiadas: "Su clave ha sido cambiada",
      infoActualizada: "Información actualizada correctamente",
      telefonoErroneo: "El teléfono indicado es erróneo",
      datosGuardados: "Datos guardados correctamente",
      errorConexion: "Error de conexión",
      urlGenerada: "URL generada. Ahora configura el webhook en Stripe y pega el Signing Secret.",
      errorGuardarClaves: "Error al guardar las claves",
      stripeGuardado: "Configuración Stripe guardada",
      errorGuardar: "Error al guardar",
      conexionCorrecta: "Conexión correcta",
      errorDesconocido: "Error desconocido",
      errorConexionServidor: "Error de conexión con el servidor.",
      suscripcionesActivasTitulo: "⚠️ Tienes suscripciones activas",
      suscripcionesActivasMsg: "Tienes {total} suscripción(es) activa(s) procesando cobros con las claves actuales. Si las cambias, los cobros mensuales dejarán de funcionar y los suscriptores serán expulsados del canal. ¿Seguro que quieres continuar?",
      siCambiar: "Sí, cambiar de todas formas",
      cancelar: "Cancelar",
    }
  },

  en: {
    pronostico: {
      discountCode: "Discount code",
      discountPlaceholder: "Ex: QUANTY10",
      applied: "Applied",
      apply: "Apply",
      onlyOneCode: "You can only use one code per purchase",
      totalToPay: "Total to pay",
      trialHoyPagas: "Today you pay",
      trialCargo: "in {days} days you will be charged",
      youSave: "YOU SAVE",
      finalChargeEuro: "Final charge in € (approximate amount in {currency}).",
      phoneInvalid: "The phone number entered is invalid",
      finalPrice: "Final price",
      processingPayment: "Processing payment… (it may take a few seconds)",
      loggedAs: "You are logged in as:",
      yourLinkIs: "This is your link:",
      goToPanel: "Go to panel",
      pay: "Pay",
      phone: "Phone",
      password: "Password",
      sendPassword: "Send me the password",
      login: "Log in",
      namePlaceholder: "Enter your name",
      name: "Name",
      acceptData: "I accept the computerized processing of the information…",
      register: "Sign up",
      telegramCode: "Code sent via Telegram",
      codePlaceholder: "Enter the code",
      confirm: "Confirm",
      directPurchaseTitle: "Direct Purchase Without Registration",
      directPurchaseSubtitle: "Make your payment with Stripe",
      email: "Email address *",
      emailPlaceholder: "you{'@'}email.com",
      emailHelp: "Enter a valid email address — we'll send your purchase details there.",
      country: "Purchase country *",
      countryPlaceholder: "Select your country",
      countryHelp: "This helps us with billing.",
      countryRequired: "Please select your country to continue.",
      acceptTerms: "I have read and confirm I am over 18 years old and accept the {aviso} and the {privacidad}.",
      continuePayment: "Continue to payment",
      back: "⬅️ Back",
      paymentCompleted: "🎉 Payment completed!",
      forecastAvailable: "Your forecast is now available. Here is your link:",
      linkPending: "Your access link is being generated. If you don't receive it within a few minutes, please contact support.",
      thanks: "The Quanty team thanks you for your trust.",
      enjoy: "Enjoy your content and… let the winning streak begin.",
      expiredTitle: "Service expired",
      expiredDefault: "This service has ended and no longer accepts new purchases.",
      backHome: "Back to home",
      reload: "Reload",
      expiredHelp: "If you think this is an error, try reloading or contact support.",
      countdownDays: "{d}d {h}h {m}m {s}s left to purchase",
      countdownHours: "{h}h {m}m {s}s left to purchase",

      couponNoAvailable: "This product has no available discounts",
      couponEnterCode: "Enter a code",
      couponAppliedOk: "Code applied successfully",
      couponInvalid: "Invalid code",
      couponCheckError: "Error checking the code",

      swalPhoneInvalid: "The phone number is invalid",
      swalNameLength: "The name must be longer than 10 characters",
      swalAcceptConditions: "You must accept the registration conditions",
      swalTelegramCode: "Enter the code sent to your Telegram",
      swalGenericError: "An error occurred",
      swalCodeSixDigits: "The code must contain 6 digits",
      swalUserRegistered: "Your user has been registered",
      swalInvalidAccess: "Invalid access data",
      swalNoPaymentConfirmation: "Payment confirmation could not be obtained.",
      swalPaymentPending: "Payment received, but the server has not confirmed it yet. Wait a few seconds and reload.",
      swalPasswordSent: "We have sent a new password to your Telegram",
      loginToPayLabel: "Log in",
      subscriptionRequiresAccount: "This subscription requires an account",
      subscriptionRequiresAccountDesc: "To purchase a subscription you must log in or create a free account.",
      subscriptionLogin: "Log in",
      subscriptionRegister: "Create free account",
      subscriptionLabel: "Subscription",
      registroInlineTitulo: "Create an account to subscribe",
      registroInlineNombre: "Name",
      registroInlineEmail: "Email",
      registroInlinePais: "Country",
      registroInlinePaisPlaceholder: "Select your country",
      registroInlinePassword: "Password",
      registroInlinePasswordConfirm: "Confirm password",
      registroInlinePasswordPlaceholder: "At least 8 characters",
      registroInlineRepeatPlaceholder: "Repeat your password",
      registroInlineLegal: "I have read and confirm I am over 18 years old and accept the {aviso} and the {privacidad}.",
      registroInlineAvisoLegal: "Legal Notice",
      registroInlinePrivacidad: "Privacy Policy",
      registroInlineBtn: "Create account and subscribe",
      registroInlineCargando: "Creating account…",
      registroInlineYaTengo: "Already have an account?",
      registroInlineIniciar: "Log in",
      registroInlineErrorNombre: "Name is required.",
      registroInlineErrorEmail: "Email is required.",
      registroInlineErrorPais: "Country is required.",
      registroInlineErrorEmailTaken: "An account with this email already exists. Log in or use a different email.",
      registroInlineErrorPassword: "Password must be at least 8 characters.",
      registroInlineErrorMatch: "Passwords do not match.",
      registroInlineErrorLegal: "You must confirm you are over 18 and accept the terms.",
      periodDiario: "day",
      periodSemanal: "week",
      periodQuincenal: "2 wks.",
      periodMensual: "month",
      periodTrimestral: "3 months",
      periodSemestral: "6 months",
      periodAnual: "year"
    },
    paymentStripe: {
      payWithCard: "PAY WITH CARD",
      cardNumber: "Card Number",
      expiry: "Expiry Date",
      securityCode: "Security Code",
      pay: "PAY",
      paymentSuccess: "✅ Payment completed successfully",
      paymentProcessingError: "An error occurred while processing the payment. Please try again.",
      paymentConfirmedButError: "⚠️ Your payment was processed by Stripe, but an error occurred activating your access. Contact support with your email and the product purchased.",
      paymentProcessing: "⏳ Your payment is being processed. You will receive confirmation shortly.",
      paymentUnexpectedStatus: "Unexpected payment status. Contact support if you did not receive access.",
      trialActivate: "ACTIVATE FREE TRIAL",
      trialStart: "START FREE TRIAL",
      trialSuccess: "✅ Free trial activated! You now have access.",
      trialDaysSingular: "free day",
      trialDaysPlural: "free days",
      trialNoChrge: "We only verify your card, no charge is made now",
      trialNote: "You can cancel at any time before the end of the free trial period.",
      trialInfoSub: "The first charge is made at the end of the trial period"
    },
    countries: {
      ES: "Spain",
      FR: "France",
      PT: "Portugal",
      DE: "Germany",
      IT: "Italy",
      NL: "Netherlands",
      BE: "Belgium",
      IE: "Ireland",
      GB: "United Kingdom",
      CH: "Switzerland",
      AT: "Austria",
      SE: "Sweden",
      NO: "Norway",
      DK: "Denmark",
      FI: "Finland",
      PL: "Poland",
      MX: "Mexico",
      AR: "Argentina",
      CL: "Chile",
      CO: "Colombia",
      PE: "Peru",
      EC: "Ecuador",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivia",
      VE: "Venezuela",
      BR: "Brazil",
      US: "United States",
      CA: "Canada",
      SV: "El Salvador",
      GT: "Guatemala",
      HN: "Honduras",
      NI: "Nicaragua",
      CR: "Costa Rica",
      PA: "Panama",
      DO: "Dominican Republic",
      CU: "Cuba",
      PR: "Puerto Rico",
      AU: "Australia"
    },
    panelCliente: {
      inicio: "Home",
      titulo: "Client Panel",
      subtitulo: "View your services, purchases and accesses linked to your account.",
      cliente: "Client",
      miCuenta: "-- My account --",
      cargandoClientes: "Loading clients...",
      actualizar: "Refresh",
      errorCargar: "Failed to load client panel",
      resumenTitulo: "Summary",
      clienteLabel: "Client:",
      serviciosComprados: "Purchased services",
      serviciosActivos: "Active services",
      canalesUnidos: "Joined channels",
      devoluciones: "Refunds",
      ultimaCompra: "Last purchase",
      sinDatos: "No purchases or accesses linked to this account yet. Once the client flow is connected, all information will appear here.",
      datosCuentaTitulo: "Account details",
      datosCuentaSubtitulo: "Basic client information",
      nombre: "Name",
      usuario: "Username",
      email: "Email",
      telegram: "Telegram",
      noVinculado: "Not linked",
      emailVerificado: "Email verified",
      si: "Yes",
      no: "No",
      alta: "Registered",
      suscrTitulo: "My subscriptions",
      suscrVacio: "No active subscriptions at this time.",
      producto: "Product",
      canal: "Channel",
      estado: "Status",
      proximoCobro: "Next billing",
      desde: "Since",
      accion: "Action",
      ultimoDiaFree: "Last free day",
      diasFree: "{n} free days",
      cancelando: "Cancelling...",
      cancelar: "Cancel",
      estadoActiva: "Active",
      estadoGracia: "Grace",
      estadoCancelada: "Cancelled",
      estadoVencida: "Expired",
      confirmarCancelTitulo: "Cancel subscription?",
      confirmarCancelMsg: 'Are you sure you want to cancel "{nombre}"? You will lose access to the channel at the end of the current period.',
      siCancelar: "Yes, cancel",
      canceladaOk: "Subscription cancelled successfully.",
      canceladaErr: "Could not cancel the subscription.",
      historialTitulo: "Order history",
      historialVacio: "No orders registered on this account yet.",
      referencia: "Reference",
      fecha: "Date",
      devolucion: "Refund",
      devolucionSolicitada: "Requested / processed",
      serviciosActivosTitulo: "Active services",
      serviciosActivosVacio: "No active services linked to this account yet.",
      tipster: "Tipster",
      fechaCompra: "Purchase date",
      acceso: "Access",
      sinEnlace: "This service has no join link available.",
      enlaceDeUnion: "Join link",
      enlaceMsg: "Service: {nombre}\n\nLink:\n{enlace}",
      cerrar: "Close",
      actividadTitulo: "Channel activity",
      actividadVacio: "No channel activity linked to this account yet.",
      idioma: "Language",
      ultimaEntrada: "Last joined",
      ultimaSalida: "Last left",
      reingresos: "Rejoins",
      activo: "Active",
      suscrPagInfo: "Showing {desde} to {hasta} of {total} subscriptions",
      historialPagInfo: "Showing {desde} to {hasta} of {total} orders",
      serviciosPagInfo: "Showing {desde} to {hasta} of {total} services",
      paginaDeTotal: "Page {page} of {total}",
    },
    perfil: {
      inicio: "Home",
      titulo: "My profile",
      infoBasicaTitulo: "Basic information",
      nombre: "Name",
      email: "Email",
      actualizar: "Update",
      datosTipsterTitulo: "Tipster data",
      contacto: "Contact",
      telefono: "Phone",
      telefonoPlaceholder: "Enter phone number",
      guardarDatos: "Save data",
      cambioClaveTitulo: "Change password",
      nuevaClave: "New password",
      confirmaNuevaClave: "Confirm new password",
      cambiarClave: "Change password",
      stripeTitulo: "Payment gateway (Stripe)",
      stripeAyudaTitulo: "What is each key?",
      clavePublica: "Public key",
      claveSecreta: "Secret key",
      configurada: "✓ Configured",
      configurado: "✓ Configured",
      generarUrl: "Generate custom URL",
      guardarParaUrl: "Save your keys to get the unique webhook URL for your account.",
      copiar: "Copy",
      copiado: "✓ Copied",
      webhookSecret: "Webhook Secret",
      suscripciones: "Subscriptions",
      graciaPagosFallidos: "Failed payment grace",
      probarConexion: "⚡ Test connection",
      guardarStripe: "Save Stripe",
      eliminarIntegracion: "To remove the custom integration, delete the public key and save with the secret key blank.",
      webhookGuiaTitulo: "⚡ How to configure the Webhook in Stripe?",
      applePayGuiaTitulo: "🍎 How to activate Apple Pay in Stripe?",
      graciaAyudaTitulo: "What is the grace period for?",
      clavesCambiadas: "Your password has been changed",
      infoActualizada: "Information updated successfully",
      telefonoErroneo: "The phone number entered is invalid",
      datosGuardados: "Data saved successfully",
      errorConexion: "Connection error",
      urlGenerada: "URL generated. Now configure the webhook in Stripe and paste the Signing Secret.",
      errorGuardarClaves: "Error saving keys",
      stripeGuardado: "Stripe configuration saved",
      errorGuardar: "Error saving",
      conexionCorrecta: "Connection successful",
      errorDesconocido: "Unknown error",
      errorConexionServidor: "Server connection error.",
      suscripcionesActivasTitulo: "⚠️ You have active subscriptions",
      suscripcionesActivasMsg: "You have {total} active subscription(s) processing payments with the current keys. If you change them, monthly billing will stop working and subscribers will be removed from the channel. Are you sure you want to continue?",
      siCambiar: "Yes, change anyway",
      cancelar: "Cancel",
    }
  },

  pt: {
    pronostico: {
      discountCode: "Código de desconto",
      discountPlaceholder: "Ex.: QUANTY10",
      applied: "Aplicado",
      apply: "Aplicar",
      onlyOneCode: "Você só pode usar um código por compra",
      totalToPay: "Total a pagar",
      trialHoyPagas: "Hoje pagarás",
      trialCargo: "em {days} dias será cobrado",
      youSave: "VOCÊ ECONOMIZA",
      finalChargeEuro: "Cobrança final em € (valor aproximado em {currency}).",
      phoneInvalid: "O telefone informado é inválido",
      finalPrice: "Preço final",
      processingPayment: "Processando pagamento… (pode levar alguns segundos)",
      loggedAs: "Você está conectado como:",
      yourLinkIs: "Este é o seu link:",
      goToPanel: "Ir para o painel",
      pay: "Pagar",
      phone: "Telefone",
      password: "Senha",
      sendPassword: "Enviar a senha",
      login: "Entrar",
      namePlaceholder: "Informe seu nome",
      name: "Nome",
      acceptData: "Aceito o tratamento informatizado das informações…",
      register: "Registrar-me",
      telegramCode: "Código enviado pelo Telegram",
      codePlaceholder: "Informe o código",
      confirm: "Confirmar",
      directPurchaseTitle: "Compra Direta Sem Registro",
      directPurchaseSubtitle: "Realize seu pagamento com Stripe",
      email: "E-mail *",
      emailPlaceholder: "voce{'@'}email.com",
      emailHelp: "Informe um e-mail válido, enviaremos os detalhes da sua compra para esse endereço.",
      country: "País da compra *",
      countryPlaceholder: "Selecione seu país",
      countryHelp: "Isso nos ajuda com a faturação.",
      countryRequired: "Por favor, selecione seu país para continuar.",
      acceptTerms: "Li e confirmo que tenho mais de 18 anos e aceito o {aviso} e a {privacidad}.",
      continuePayment: "Continuar para o pagamento",
      back: "⬅️ Voltar",
      paymentCompleted: "🎉 Pagamento concluído!",
      forecastAvailable: "Seu prognóstico já está disponível. Aqui está seu link:",
      linkPending: "Seu link de acesso está sendo gerado. Se não o receber em alguns minutos, entre em contato com o suporte.",
      thanks: "A equipe da Quanty agradece sua confiança.",
      enjoy: "Aproveite seu conteúdo e… que comece a sequência vencedora.",
      expiredTitle: "Serviço expirado",
      expiredDefault: "Este serviço foi encerrado e não aceita novas compras.",
      backHome: "Voltar ao início",
      reload: "Recarregar",
      expiredHelp: "Se você acha que isso é um erro, tente recarregar ou entre em contato com o suporte.",
      countdownDays: "Faltam {d}d {h}h {m}m {s}s para adquirir",
      countdownHours: "Faltam {h}h {m}m {s}s para adquirir",

      couponNoAvailable: "Este produto não tem descontos disponíveis",
      couponEnterCode: "Informe um código",
      couponAppliedOk: "Código aplicado com sucesso",
      couponInvalid: "Código inválido",
      couponCheckError: "Erro ao verificar o código",

      swalPhoneInvalid: "O telefone é inválido",
      swalNameLength: "O nome deve ter mais de 10 caracteres",
      swalAcceptConditions: "Você deve aceitar as condições de registro",
      swalTelegramCode: "Informe o código enviado ao seu Telegram",
      swalGenericError: "Ocorreu um erro",
      swalCodeSixDigits: "O código deve ter 6 números",
      swalUserRegistered: "Seu usuário foi registrado",
      swalInvalidAccess: "Dados de acesso inválidos",
      swalNoPaymentConfirmation: "Não foi possível obter a confirmação do pagamento.",
      swalPaymentPending: "Pagamento recebido, mas o servidor ainda não o confirmou. Aguarde alguns segundos e recarregue.",
      swalPasswordSent: "Enviamos uma nova senha para o seu Telegram",
      loginToPayLabel: "Iniciar sessão",
      subscriptionRequiresAccount: "Esta subscrição requer uma conta",
      subscriptionRequiresAccountDesc: "Para comprar uma subscrição deves iniciar sessão ou criar uma conta gratuita.",
      subscriptionLogin: "Iniciar sessão",
      subscriptionRegister: "Criar conta grátis",
      subscriptionLabel: "Subscrição",
      registroInlineTitulo: "Criar conta para subscrever",
      registroInlineNombre: "Nome",
      registroInlineEmail: "Email",
      registroInlinePais: "País",
      registroInlinePaisPlaceholder: "Seleciona o teu país",
      registroInlinePassword: "Senha",
      registroInlinePasswordConfirm: "Confirmar senha",
      registroInlinePasswordPlaceholder: "Mínimo 8 caracteres",
      registroInlineRepeatPlaceholder: "Repete a senha",
      registroInlineLegal: "Li e confirmo que tenho mais de 18 anos e aceito o {aviso} e a {privacidad}.",
      registroInlineAvisoLegal: "Aviso Legal",
      registroInlinePrivacidad: "Política de Privacidade",
      registroInlineBtn: "Criar conta e subscrever",
      registroInlineCargando: "Criando conta…",
      registroInlineYaTengo: "Já tens uma conta?",
      registroInlineIniciar: "Iniciar sessão",
      registroInlineErrorNombre: "O nome é obrigatório.",
      registroInlineErrorEmail: "O email é obrigatório.",
      registroInlineErrorPais: "O país é obrigatório.",
      registroInlineErrorEmailTaken: "Já existe uma conta com esse email. Faça login ou use outro email.",
      registroInlineErrorPassword: "A senha deve ter pelo menos 8 caracteres.",
      registroInlineErrorMatch: "As senhas não coincidem.",
      registroInlineErrorLegal: "Deves confirmar que tens mais de 18 anos e aceitar as condições.",
      periodDiario: "dia",
      periodSemanal: "semana",
      periodQuincenal: "2 sem.",
      periodMensual: "mês",
      periodTrimestral: "3 meses",
      periodSemestral: "6 meses",
      periodAnual: "ano"
    },
    paymentStripe: {
      payWithCard: "PAGAR COM CARTÃO",
      cardNumber: "Número do Cartão",
      expiry: "Validade",
      securityCode: "Código de Segurança",
      pay: "PAGAR",
      paymentSuccess: "✅ Pagamento realizado com sucesso",
      paymentProcessingError: "Ocorreu um erro ao processar o pagamento. Tente novamente.",
      paymentConfirmedButError: "⚠️ Seu pagamento foi processado pelo Stripe, mas ocorreu um erro ao ativar seu acesso. Entre em contato com o suporte informando seu email e o produto comprado.",
      paymentProcessing: "⏳ Seu pagamento está sendo processado. Você receberá uma confirmação em breve.",
      paymentUnexpectedStatus: "Status de pagamento inesperado. Entre em contato com o suporte se não recebeu o acesso.",
      trialActivate: "ATIVAR PERÍODO DE AVALIAÇÃO",
      trialStart: "COMEÇAR AVALIAÇÃO GRATUITA",
      trialSuccess: "✅ Período de avaliação ativado! Você já tem acesso.",
      trialDaysSingular: "dia grátis",
      trialDaysPlural: "dias grátis",
      trialNoChrge: "Apenas verificamos o seu cartão, nenhuma cobrança é feita agora",
      trialNote: "Pode cancelar a qualquer momento antes do fim do período gratuito.",
      trialInfoSub: "A primeira cobrança é feita no fim do período de avaliação"
    },
    countries: {
      ES: "Espanha",
      FR: "França",
      PT: "Portugal",
      DE: "Alemanha",
      IT: "Itália",
      NL: "Países Baixos",
      BE: "Bélgica",
      IE: "Irlanda",
      GB: "Reino Unido",
      CH: "Suíça",
      AT: "Áustria",
      SE: "Suécia",
      NO: "Noruega",
      DK: "Dinamarca",
      FI: "Finlândia",
      PL: "Polônia",
      MX: "México",
      AR: "Argentina",
      CL: "Chile",
      CO: "Colômbia",
      PE: "Peru",
      EC: "Equador",
      UY: "Uruguai",
      PY: "Paraguai",
      BO: "Bolívia",
      VE: "Venezuela",
      BR: "Brasil",
      US: "Estados Unidos",
      CA: "Canadá",
      SV: "El Salvador",
      GT: "Guatemala",
      HN: "Honduras",
      NI: "Nicaragua",
      CR: "Costa Rica",
      PA: "Panamá",
      DO: "Rep. Dominicana",
      CU: "Cuba",
      PR: "Puerto Rico",
      AU: "Austrália"
    }
  },

  fr: {
    pronostico: {
      discountCode: "Code promo",
      discountPlaceholder: "Ex. : QUANTY10",
      applied: "Appliqué",
      apply: "Appliquer",
      onlyOneCode: "Vous ne pouvez utiliser qu’un seul code par achat",
      totalToPay: "Total à payer",
      trialHoyPagas: "Aujourd'hui vous payez",
      trialCargo: "dans {days} jours un paiement de",
      youSave: "VOUS ÉCONOMISEZ",
      finalChargeEuro: "Débit final en € (montant approximatif en {currency}).",
      phoneInvalid: "Le numéro de téléphone indiqué est invalide",
      finalPrice: "Prix final",
      processingPayment: "Traitement du paiement… (cela peut prendre quelques secondes)",
      loggedAs: "Vous êtes connecté en tant que :",
      yourLinkIs: "Voici votre lien :",
      goToPanel: "Aller au panneau",
      pay: "Payer",
      phone: "Téléphone",
      password: "Mot de passe",
      sendPassword: "Envoyez-moi le mot de passe",
      login: "Se connecter",
      namePlaceholder: "Indiquez votre nom",
      name: "Nom",
      acceptData: "J’accepte le traitement informatisé des informations…",
      register: "M’inscrire",
      telegramCode: "Code envoyé par Telegram",
      codePlaceholder: "Indiquez le code",
      confirm: "Confirmer",
      directPurchaseTitle: "Achat direct sans inscription",
      directPurchaseSubtitle: "Effectuez votre paiement avec Stripe",
      email: "Adresse e-mail *",
      emailPlaceholder: "vous{'@'}email.com",
      emailHelp: "Saisissez un e-mail valide, nous vous enverrons les détails de votre achat à cette adresse.",
      country: "Pays d’achat *",
      countryPlaceholder: "Sélectionnez votre pays",
      countryHelp: "Cela nous aide pour la facturation.",
      countryRequired: "Veuillez sélectionner votre pays pour continuer.",
      acceptTerms: "J’ai lu et je confirme avoir plus de 18 ans et j’accepte les {aviso} et la {privacidad}.",
      continuePayment: "Continuer vers le paiement",
      back: "⬅️ Retour",
      paymentCompleted: "🎉 Paiement effectué !",
      forecastAvailable: "Votre pronostic est maintenant disponible. Voici votre lien :",
      linkPending: "Votre lien d’accès est en cours de génération. Si vous ne le recevez pas dans quelques minutes, contactez le support.",
      thanks: "L’équipe Quanty vous remercie de votre confiance.",
      enjoy: "Profitez de votre contenu et… que la série gagnante commence.",
      expiredTitle: "Service expiré",
      expiredDefault: "Ce service est terminé et n’accepte plus de nouveaux achats.",
      backHome: "Retour à l’accueil",
      reload: "Recharger",
      expiredHelp: "Si vous pensez qu’il s’agit d’une erreur, essayez de recharger ou contactez le support.",
      countdownDays: "Il reste {d}j {h}h {m}m {s}s pour acheter",
      countdownHours: "Il reste {h}h {m}m {s}s pour acheter",

      couponNoAvailable: "Ce produit n’a pas de remises disponibles",
      couponEnterCode: "Entrez un code",
      couponAppliedOk: "Code appliqué avec succès",
      couponInvalid: "Code invalide",
      couponCheckError: "Erreur lors de la vérification du code",

      swalPhoneInvalid: "Le téléphone est invalide",
      swalNameLength: "Le nom doit contenir plus de 10 caractères",
      swalAcceptConditions: "Vous devez accepter les conditions d’inscription",
      swalTelegramCode: "Indiquez le code envoyé sur votre Telegram",
      swalGenericError: "Une erreur s’est produite",
      swalCodeSixDigits: "Le code doit contenir 6 chiffres",
      swalUserRegistered: "Votre utilisateur a été enregistré",
      swalInvalidAccess: "Données d’accès invalides",
      swalNoPaymentConfirmation: "Impossible d’obtenir la confirmation du paiement.",
      swalPaymentPending: "Paiement reçu, mais le serveur ne l’a pas encore confirmé. Attendez quelques secondes puis rechargez.",
      swalPasswordSent: "Nous avons envoyé un nouveau mot de passe à votre Telegram",
      loginToPayLabel: "Se connecter",
      subscriptionRequiresAccount: "Cet abonnement nécessite un compte",
      subscriptionRequiresAccountDesc: "Pour acheter un abonnement, vous devez vous connecter ou créer un compte gratuit.",
      subscriptionLogin: "Se connecter",
      subscriptionRegister: "Créer un compte gratuit",
      subscriptionLabel: "Abonnement",
      registroInlineTitulo: "Créer un compte pour s'abonner",
      registroInlineNombre: "Nom",
      registroInlineEmail: "Email",
      registroInlinePais: "Pays",
      registroInlinePaisPlaceholder: "Sélectionne ton pays",
      registroInlinePassword: "Mot de passe",
      registroInlinePasswordConfirm: "Confirmer le mot de passe",
      registroInlinePasswordPlaceholder: "Au moins 8 caractères",
      registroInlineRepeatPlaceholder: "Répétez le mot de passe",
      registroInlineLegal: "J'ai lu et je confirme avoir plus de 18 ans et j'accepte les {aviso} et la {privacidad}.",
      registroInlineAvisoLegal: "Mentions Légales",
      registroInlinePrivacidad: "Politique de Confidentialité",
      registroInlineBtn: "Créer un compte et s'abonner",
      registroInlineCargando: "Création du compte…",
      registroInlineYaTengo: "Vous avez déjà un compte ?",
      registroInlineIniciar: "Se connecter",
      registroInlineErrorNombre: "Le nom est obligatoire.",
      registroInlineErrorEmail: "L'email est obligatoire.",
      registroInlineErrorPais: "Le pays est obligatoire.",
      registroInlineErrorEmailTaken: "Un compte avec cet email existe déjà. Connectez-vous ou utilisez un autre email.",
      registroInlineErrorPassword: "Le mot de passe doit comporter au moins 8 caractères.",
      registroInlineErrorMatch: "Les mots de passe ne correspondent pas.",
      registroInlineErrorLegal: "Vous devez confirmer avoir plus de 18 ans et accepter les conditions.",
      periodDiario: "jour",
      periodSemanal: "semaine",
      periodQuincenal: "2 sem.",
      periodMensual: "mois",
      periodTrimestral: "3 mois",
      periodSemestral: "6 mois",
      periodAnual: "an"
    },
    paymentStripe: {
      payWithCard: "PAYER PAR CARTE",
      cardNumber: "Numéro de Carte",
      expiry: "Date d’expiration",
      securityCode: "Code de sécurité",
      pay: "PAYER",
      paymentSuccess: "✅ Paiement effectué avec succès",
      paymentProcessingError: "Une erreur s’est produite lors du traitement du paiement. Veuillez réessayer.",
      paymentConfirmedButError: "⚠️ Votre paiement a été traité par Stripe, mais une erreur s’est produite lors de l’activation de votre accès. Contactez le support en indiquant votre email et le produit acheté.",
      paymentProcessing: "⏳ Votre paiement est en cours de traitement. Vous recevrez une confirmation sous peu.",
      paymentUnexpectedStatus: "Statut de paiement inattendu. Contactez le support si vous n’avez pas reçu l’accès.",
      trialActivate: "ACTIVER LA PÉRIODE D’ESSAI",
      trialStart: "COMMENCER L’ESSAI GRATUIT",
      trialSuccess: "✅ Période d’essai activée ! Vous avez maintenant accès.",
      trialDaysSingular: "jour gratuit",
      trialDaysPlural: "jours gratuits",
      trialNoChrge: "Nous vérifions uniquement votre carte, aucun prélèvement n’est effectué maintenant",
      trialNote: "Vous pouvez annuler à tout moment avant la fin de la période gratuite.",
      trialInfoSub: "Le premier prélèvement est effectué à la fin de la période d’essai"
    },
    countries: {
      ES: "Espagne",
      FR: "France",
      PT: "Portugal",
      DE: "Allemagne",
      IT: "Italie",
      NL: "Pays-Bas",
      BE: "Belgique",
      IE: "Irlande",
      GB: "Royaume-Uni",
      CH: "Suisse",
      AT: "Autriche",
      SE: "Suède",
      NO: "Norvège",
      DK: "Danemark",
      FI: "Finlande",
      PL: "Pologne",
      MX: "Mexique",
      AR: "Argentine",
      CL: "Chili",
      CO: "Colombie",
      PE: "Pérou",
      EC: "Équateur",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivie",
      VE: "Venezuela",
      BR: "Brésil",
      US: "États-Unis",
      CA: "Canada",
      SV: "El Salvador",
      GT: "Guatemala",
      HN: "Honduras",
      NI: "Nicaragua",
      CR: "Costa Rica",
      PA: "Panama",
      DO: "Rép. Dominicaine",
      CU: "Cuba",
      PR: "Porto Rico",
      AU: "Australie"
    }
  }
};

const i18n = createI18n({
  legacy: true,
  locale: savedLocale,
  fallbackLocale: "es",
  messages
});

export default i18n;